import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { BsTrash } from "react-icons/bs";
import { useFormik } from "formik";
import { MdClose } from "react-icons/md";
import * as Yup from "yup";
import { useTheme } from "../../../hooks/useTheme";
import useApi from "../../../hooks/useApi";
import { useAuth } from "../../../hooks/useAuth";
import { v4 as uuidv4 } from "uuid";
import filesize from "filesize";
import {
  getHours,
  getMinutes,
  format,
} from "date-fns";

import Accessibility from "../../../components/UI/Accessibility";
import Menu from "../../../components/UI/Menu";
import Error from "../../../components/UI/Error";
import Footer from "../../../components/UI/Footer";
import ContentBox from "../../../components/UI/ContentBox";
import {
  Container,
  Title,
  Form,
  Item,
  ItemFloor,
  ListBox,
  Place,
  Controls,
  DeleteEvent,
  DocumentContainer,
  DocumentUrl,
  DocumentFile,
  DocumentName,
  DocumentSize,
  DocumentDeleteButton,
  Grade,
  ListButton,
  InputSegment,
  Tutor,
  ModalTutor,
  MeetModal,
  MeetInfo,
  TutorInfo,
  ContentVisibility,
  RulesBlockModal,
  Alert,
} from "./styles";
import InputText from "../../../components/UI/Inputs/InputText";
import InputCheck from "../../../components/UI/Inputs/InputCheck";
import InputCheckButton from "../../../components/UI/Inputs/InputCheckButton";
import CancelButton from "../../../components/UI/CancelButton";
import ConfirmButton from "../../../components/UI/ConfirmButton";
import DeleteButton from "../../../components/UI/DeleteButton";
import InputRadio from "../../../components/UI/Inputs/InputRadio";
import InputFile from "../../../components/UI/Inputs/InputFile";
import InputDate from "../../../components/UI/Inputs/InputDate";
import InputTime from "../../../components/UI/Inputs/InputTime";
import FullScreenLoading from "../../../components/UI/FullScreenLoading";
import InputSelect from "../../../components/UI/Inputs/InputSelect";
import Modal from "../../../components/UI/Modal";
import ReadMoreButton from "../../../components/UI/ReadMoreButton";


const CourseForm = ({ action }) => {
  const { themeFile } = useTheme();
  const { user } = useAuth();
  const [categories, setCategories] = useState([]);
  const [segmento, setSegmento] = useState([]);
  const [visibilities, setVisibilities] = useState([]);
  const [subscriptionRules, setSubscriptionRules] = useState([]);
  const [schoolGradeList, setSchoolGradeList] = useState([]);
  const [tutorList, setTutorList] = useState([]);
  const [profileList, setProfileList] = useState([]);
  const { id } = useParams();

  const [queueList, setQueueList] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalSegmentOpen, setModalSegmentOpen] = useState(false);

  const [modalSegmentMessage, setModalSegmentMessage] = useState({open:false,message:"",load:false});

  const [finaliza, setFinaliza] = useState(false);

  const [createSegment, setCreateSegment] = useState("");

  const [tempTutors, setTempTutors] = useState([]);
  const [modalTutor, setModalTutor] = useState(false);

  const [modalMeetOpen, setModalMeetOpen] = useState(false);

  const [modalRulesOpen, setModalRulesOpen] = useState(false);

  const navigate = useNavigate();

  const checkHorario = (begin,end) => {
    console.log("checkHorario",`${getHours(new Date(begin))}:${getMinutes(new Date(begin))}<${getHours(new Date(end))}:${getMinutes(new Date(end))}`);
    if(getHours(new Date(begin))<getHours(new Date(end))){
      console.log("Hora true");
      return true;
    }
    else{
      if(getHours(new Date(begin))===getHours(new Date(end))){
        if(getMinutes(new Date(begin))<getMinutes(new Date(end))){
          console.log("Minuto true");
          return true;
        } 
      }
      console.log("horario errado");
      return false;
    }
  };

  const checkInt = (value) => {
    if (value !== "" && !isNaN(value)) {
      return parseInt(value);
    }
    return value;
  };

  const formik = useFormik({
    initialValues: {
      useGoogleClassroom: false,
      courseType: "",
      courseWorkload:0,
      segment:"",
      title: "",
      formType: "public",
      description: "",
      teacher: "",
      teacherContact: "",
      documents: [],
      deletedIds: [],
      visibilities: [],
      iduserTutor:"",
      tutors:[],
      meetings: [],
      meet:{
          id: "",
          eventDate: "",
          eventBegin: "",
          eventEnd: "",
          place: "",
        },
      hasSubscription: false,
      subscriptionRules:[],
      subscriptionsLimit: 1,
      subscriptionBegin: "",
      subscriptionEnd: "",
      hasNumberOfClass:false,
      initialClassNumber:1,
      finalClassNumber:1,      
    },
    validationSchema: Yup.object({
      meetings: Yup.array(),
      formType: Yup.string().required(),
      courseType: Yup.string().required(),
      title: Yup.string().required("Digite o título."),
      description: Yup.string().required("Digite a descrição."),
      teacher: Yup.string().required("Digite o(s) nome(s) do(s) formador(es)."),
      teacherContact: Yup.string().required(
        "Digite um contato para a formação."
      ),
      visibilities: Yup.array().when("formType", {
        is: "private",
        then: Yup.array().min(1, "Selecione 1"),
      }),
      hasSubscription: Yup.bool(),
      subscriptionBegin: Yup.number().test(
          "test-begin",
          "Data inicial deve ser menor que a data final",
          function checkEnd(subscriptionBegin) {
            const { subscriptionEnd } = this.parent;
            if (!(subscriptionEnd && subscriptionBegin)){
              return true;
            }
            if ((subscriptionBegin <= subscriptionEnd)) {
              return true;
            } else {
              return false;
            }
          }
      ).required("Selecione a data de início das inscrições."),
      subscriptionEnd: Yup.number().test(
        "test-End",
        "Data Final deve ser maior que a data inicial",
        function checkBegin(subscriptionEnd) {
          const { subscriptionBegin } = this.parent;
          if (!(subscriptionEnd && subscriptionBegin)){
            return true;
          }
          if ((subscriptionBegin <= subscriptionEnd)) {
            return true;
          } else {
            return false;
          }
        }
    ).required("Selecione a data final das inscrições."),
      subscriptionsLimit: Yup.number().when("hasSubscription", {
        is: true,
        then: Yup.number().min(1, "Defina o limite de incrições para pelo menos 1").required("Digite o numero de inscritos para a formação"),
      }),
      subscriptionRules: Yup.array(),
      hasNumberOfClass: Yup.boolean(),
      initialClassNumber: Yup.number().test("","O numero da turma inicial tem que ser menor ou igual do que da turma final",
                      (initialClassNumber, other)=>{
                        const {hasNumberOfClass, finalClassNumber} = other.parent;
                        if(hasNumberOfClass){
                          if(initialClassNumber>finalClassNumber){
                            return false;
                          }
                        }
                        return true;
                      }),
      finalClassNumber: Yup.number().test("","O numero da turma final tem que ser maior ou igual do que da turma inicial",
                      (finalClassNumber, other)=>{
                        const {hasNumberOfClass, initialClassNumber} = other.parent;
                        if(hasNumberOfClass){
                          if(initialClassNumber>finalClassNumber){
                            return false;
                          }
                        }
                        return true;
                      }),
      useGoogleClassroom: Yup.bool(),
    }),
    validateOnMount: true,
    enableReinitialize: true,
    onSubmit: (values) => {
      let createQueueList = [];
      let form;
      if(values.hasNumberOfClass){
        for(let i=values.initialClassNumber; i<=values.finalClassNumber; i++){
          let queue;
          queue = createForm(values,i);
          createQueueList.push({queue,turma:i,status:"aguardando"});
        }
      }
      else{
        form = createForm(values);
        console.log("form",form);
        // for (var pair of form.entries()) {
        //   console.log(pair[0]+ ', ' + pair[1]);
        // }
      }

      if (action === "add") {
        if(values.hasNumberOfClass){
          setQueueList(createQueueList);
          setFinaliza(false);
          setModalOpen(true);
        }
        else{
          saveItem({
            data:form,
          });
        }
        
      } else {
        editItem({
          data: form,
        });
      }

      // console.log("form",form,"\ncreateQueueList",createQueueList);
    },
  });

  const formikMeet = useFormik({
    initialValues: {
      meet:{
          id: "",
          eventDate: "",
          eventBegin: "",
          eventEnd: "",
          place: "",
        },
    },
    validationSchema: Yup.object({
      meet: Yup.object().shape({
          place: Yup.string().required("Insira o local de encontro."),
          eventDate: Yup.number().required("Selecione a data de início."),
          eventBegin: Yup.number().test(
            "test-eventbegin",
            "Horario inicial deve ser menor que o horário final",
            function checkEnd(eventBegin) {
              const { eventEnd } = this.parent;
              if (eventEnd === "" || eventBegin === ""){
                return true;
              }
              return checkHorario(checkInt(eventBegin),checkInt(eventEnd));
            }).required("Selecione a previsão de início."),
          eventEnd: Yup.number().test(
            "test-eventend",
            "Horario inicial deve ser menor que o horário final",
            function checkEnd(eventEnd) {
              const { eventBegin } = this.parent;
              if (eventEnd === "" || eventBegin === ""){
                return true;
              }
              return checkHorario(checkInt(eventBegin),checkInt(eventEnd));
            }).required("Selecione a Previsão de término"),
        }),
    }),
    validateOnMount: true,
    enableReinitialize: true,
  });

  const createForm = (values,turma=null)=>{
    let form = new FormData();
    form.append("useGoogleClassroom", values.useGoogleClassroom );
    form.append("courseType", values.courseType);
    form.append("id", values.id);
    form.append("title", `${values.title} ${turma?`(Turma ${turma})`:''}`);
    form.append("formType", values.formType);
    form.append("description", values.description);
    form.append("teacher", values.teacher);
    form.append("teacherContact", values.teacherContact);
    form.append("courseWorkload", values.courseWorkload);
    values.documents.map((item) => {
      return form.append("file", item.file);
    });
    let meetings = [];
    values.meetings.forEach((meeting) =>{
      meetings.push({...meeting,id: uuidv4()});
    });
    form.append("meetings", JSON.stringify(meetings));
    form.append("visibilities", JSON.stringify(values.visibilities));
    form.append("deletedIds", JSON.stringify(values.deletedIds));

    form.append("hasSubscription", values.hasSubscription);

    let subscriptionRules = [];
    values.subscriptionRules.forEach((rule)=>{
      subscriptionRules.push(JSON.parse(rule));
    });

    form.append("subscriptionRules", JSON.stringify(subscriptionRules));

    form.append("subscriptionsLimit", values.subscriptionsLimit);
    form.append("subscriptionBegin", values.subscriptionBegin);
    form.append("subscriptionEnd", values.subscriptionEnd);
    form.append("segment", values.segment);
    form.append("iduserTutor", values.iduserTutor);
    form.append("tutors", JSON.stringify(values.tutors));

    return form;
  };

  const handleDelete = (itemId) => {
    const confirm = window.confirm("Deseja apagar esse item?");

    if (confirm) {
      deleteItem({
        data: {
          id: itemId,
        },
      });
    }
  };

  const [saveItem, saveItemInfo] = useApi({
      debounceDelay: 0,
      baseURL: process.env.REACT_APP_CDN_API,
      multi: true,
      url: "canalPedagogico/course",
      method: "post",
      onCompleted: (response) => {
        if (!response.error) {
          console.log(response);
          navigate("/formacoes");
        }
      },
      onError: (error)=>{
        console.log("error",error);
      },
    });
  
    const [saveItemList, saveItemListInfo] = useApi({
      debounceDelay: 0,
      baseURL: process.env.REACT_APP_CDN_API,
      multi: true,
      url: "canalPedagogico/course",
      method: "post",
      onCompleted: (response) => {
        if (!response.error) {
          let tempList = [];
          queueList.forEach((queue)=>{
            if(queue.status==="iniciado"){
              tempList.push({...queue,status:"pronto"});
            }
            else{
              tempList.push(queue);
            }
          });
          setQueueList(tempList);
        }
        else{
          
        }
      },
      onError: (error)=>{
        let tempList = [];
        queueList.forEach((queue)=>{
          if(queue.status==="iniciado"){
            tempList.push({...queue,status:"Erro"});
          }
          else{
            tempList.push(queue);
          }
        });
        setQueueList(tempList);
      },
    });

    const [loadItem, loadItemInfo] = useApi({
      debounceDelay: 0,
      url: "canalPedagogico/course",
      method: "get",
      onCompleted: (response) => {
        if (!response.error) {
          console.log("load", response);
          if (response.data.length > 0) {
            let vis = [];
            if (response.data[0].visibilities.length > 0) {
              response.data[0].visibilities.forEach((oldVis) => {
                vis.push(oldVis.idvisibility);
              });
            }
            const oldMeetings = response.data[0].meetings;
            let newMeetings = [];
            if (oldMeetings.length > 0) {
              oldMeetings.map((meet) => {
                let newMeet;
                if (action === "edit"){
                  newMeet = {
                    ...meet,
                    eventBegin: parseInt(meet.eventBegin),
                    eventEnd: parseInt(meet.eventEnd),
                    eventDate: parseInt(meet.eventDate),
                  };
                }
                if (action === "add"){
                  newMeet = {
                    ...meet,
                    id:uuidv4(),
                    eventBegin: parseInt(meet.eventBegin),
                    eventEnd: parseInt(meet.eventEnd),
                    eventDate: parseInt(meet.eventDate),
                  };
                }
                return newMeetings.push(newMeet);
              });
            } else {
              newMeetings = [...oldMeetings];
            }
  
            let rules = [];
            if(response.data[0].subscriptionRules.length>0){
              response.data[0].subscriptionRules.forEach((rule) => {
                rules.push(JSON.stringify({
                  idSubscriptionRule:rule.idSubscriptionRule,
                  value:rule.value,
                }));
              });
            }
  
            const initial = {
              ...response.data[0],
              meetings: newMeetings,
              deletedIds: [],
              visibilities: vis,
              subscriptionRules: rules,
              subscriptionRulesData: response.data[0].subscriptionRules,
              useGoogleClassroom:response.data[0].useGoogleClassroom?true:false,
            };
            formik.setValues(initial);
            formikMeet.setFieldValue("meet", newMeetings.length===0?formikMeet.values.meet:newMeetings[(newMeetings.length-1)]);
          } else {
            navigate("/formacoes");
          }
        }
      },
    });
  
    const [editItem, editItemInfo] = useApi({
      debounceDelay: 0,
      baseURL: process.env.REACT_APP_CDN_API,
      multi: true,
      url: "canalPedagogico/course",
      method: "put",
      onCompleted: (response) => {
        if (!response.error) {
          console.log("editou", response);
          navigate("/formacoes");
        }
      },
    });

  const [loadCategories, loadCategoriesInfo] = useApi({
      debounceDelay: 0,
      url: "canalPedagogico/category",
      method: "get",
      onCompleted: (response) => {
        if (!response.error) {
          console.log("Categories",response);
          setCategories(response.data);
        }
      },
    });

  const [loadSegmento, loadSegmentoInfo] = useApi({
      debounceDelay: 0,
      url: "canalPedagogico/category",
      method: "get",
      onCompleted: (response) => {
        if (!response.error) {
          console.log("segmento", response);
          setSegmento(response.data);
          if(response.data.length===0){
            formik.setFieldValue("segment", "");
          }
        }
      },
    });

  const [postSegmento, postSegmentoInfo] = useApi({
      debounceDelay: 0,
      url: "canalPedagogico/category",
      method: "post",
      onCompleted: (response) => {
        if (!response.error) {
          // console.log("response");
          setModalSegmentOpen(false);
          setModalSegmentMessage({open:true,message:"Segmento criado com sucesso!",load:true});        
        }
      },
      onError: (error)=>{ 
        console.log(error);
        setModalSegmentMessage({open:true,message:"Erro ao criar Segmento",load:false});        
      },
    });

  const [loadVisibilities, loadVisibilitiesInfo] = useApi({
      debounceDelay: 0,
      url: "canalPedagogico/visibility",
      method: "get",
      onCompleted: (response) => {
        if (!response.error) {
          // console.log("visibilities", response);
          setVisibilities(response.data);
        }
      },
    });

  const [loadTutorList, loadTutorListInfo] = useApi({
      debounceDelay: 0,
      url: "canalPedagogico/profile/v2",
      method: "get",
      onCompleted: (response) => {
        if (!response.error) {
          // console.log("TutorList", response);
          setTutorList(response.data);
        }
      },
    });

  const [loadSubscriptionRules, loadSubscriptionRulesInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/course/subscriptionRules",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("SubscriptionRules", response);
        setSubscriptionRules(response.data);
      }
    },
  });

  const [loadSchoolGradeList, loadSchoolGradeListInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/schoolGradeList",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        // console.log("SchoolGradeList", response);
        setSchoolGradeList(response.data);
      }
    },
  });

  const [loadProfileList, loadProfileListInfo] = useApi({
    debounceDelay: 0,
    url: "canalPedagogico/profile/profiles",
    method: "get",
    onCompleted: (response) => {
      if (!response.error) {
        console.log("ProfileList", response);
        setProfileList(response.data);
      }
    },
  });

  const [deleteItem, deleteItemInfo] = useApi({
      debounceDelay: 0,
      url: "canalPedagogico/course",
      method: "delete",
      onCompleted: (response) => {
        if (!response.error) {
          navigate("/formacoes");
          // console.log("deletou", response);
        }
      },
    });

    /*---------- Begin Manipulação de encontros ----------*/

    const handleDeleteMeet = (meetId) => {
      let newArray = [
        ...formik.values.meetings.filter((item) => item.id !== meetId),
      ];
      formik.setFieldValue("meetings", newArray);
    };

    const handleMeet = (meet) => {
      let newArray = [
        ...formik.values.meetings,
        meet
      ];
      formik.setFieldValue("meetings", newArray);
    };

    const resetMeet = () => {
      if(formik.values.meetings.length>0){
        let lastmeet = formik.values.meetings[(formik.values.meetings.length-1)];
        formikMeet.setFieldValue("meet", lastmeet);
      }
    }

    /*---------- End Manipulação de encontros ----------*/

    /*---------- Begin Manipulação de arquivos ----------*/

    const handleFileType = (fileType) => {
      switch (fileType[0]) {
        case "image":
          return {
            type: "image",
            extension: fileType[1],
          };
        case "application":
          if (fileType[1] === "pdf") {
            return {
              type: "pdf",
              extension: fileType[1],
            };
          }else if (fileType[1] === "vnd.openxmlformats-officedocument.presentationml.presentation"){
            return {
              type: "pptx", 
              extension: "pptx"
            };
          }
          break;
        case "video":
          return {
            type: "video",
            extension: fileType[1],
          };

        default:
          break;
      }
    };

    const handleAttachFiles = (event) => {
      const file = event.target.files[0];

      const exists = formik.values.documents.filter(
        (item) => item.originalName === file.name
      );

      if (exists.length > 0) return false;

      const fileType = handleFileType(file.type.split("/"));
      event.target.value = null;

      const newName = `material_${uuidv4()}.${fileType.extension}`;

      const newFile = {
        id: uuidv4(),
        originalName: file.name,
        newName,
        file,
        sizeInBytes: file.size,
        formatSize: filesize(file.size),
        fileType,
      };

      let newArray = [...formik.values.documents];
      newArray.push(newFile);
      formik.setFieldValue("documents", newArray);
    };

    const handleDeleteDocument = (docId) => {
      let newArray = [
        ...formik.values.documents.filter((item) => item.id !== docId),
      ];
      formik.setFieldValue("documents", newArray);

      if (action === "edit") {
        const deletedIds = [...formik.values.deletedIds, docId];
        formik.setFieldValue("deletedIds", deletedIds);
      }
    };

    /*---------- End Manipulação de arquivos ----------*/

    /*---------- End Manipulação de tutores ----------*/

    const openTutors = () => {
      setTempTutors(formik.values.tutors)
      setModalTutor(true);
    }

    const updateTutors = () => {
      formik.setFieldValue("tutors", tempTutors);
      setModalTutor(false);
    }

    const handleTutors = (tutor) => {
      if (tempTutors.findIndex((temp)=>{return temp===tutor})<0){
        setTempTutors([...tempTutors,tutor]);
      }
      else{
        setTempTutors(tempTutors.filter((temp)=>{return temp!==tutor}));
      }
    }

    /*---------- End Manipulação de tutores ----------*/

    useEffect(() => {
        async function load() {
          await loadCategories({
            params: {
              id: "0e3b686a-9b75-4de0-a2b7-28ec578e8119",
              idUserHasProfile: user.profiles[0].idUserHasProfile,
            },
          });

          await loadVisibilities();

          await loadTutorList({params:{idProfile:"b56d58fe-2377-4428-854d-5f20670fb166"}});

          await loadSubscriptionRules();

          await loadSchoolGradeList({
            params:{
              showedInSubscription:true
            }
          });

          await loadProfileList();

          if (action === "edit") {
            // console.log("id", id);
            await loadItem({
              params: {
                id,
              },
            });
          } else {
            if(id){
              // console.log("id", id);
              await loadItem({
                params: {
                  id,
                },
              });
            }
            else{
              // formik.setFieldValue("meetings[0].id", uuidv4());
            }
          }
        }
        load();
        // eslint-disable-next-line
      }, []);
    
    useEffect(()=>{
        console.log("formik.value.courseType",formik.values.courseType);
        loadSegmento({
          params: {
            id: formik.values.courseType,
          }
        });
        // eslint-disable-next-line
      },[formik.values.courseType]);

    useEffect(()=>{
        console.log("formik",formik)
        // eslint-disable-next-line
      },[formik]);

    const getGrade = (id)=>{return schoolGradeList.find((grade)=>{return grade.id===id})?.title;};

    const getProfile = (id)=>{return profileList.find((profile)=>{return profile.idProfile===id})?.profileName;};

    useEffect(()=>{
        // console.log("queueList",queueList);
        let pending = queueList.filter((queue)=>{return queue.status === "aguardando" })
        let ready = queueList.filter((queue)=>{return queue.status === "iniciado" })
        if(ready.length>0){
          setTimeout(()=>{
            saveItemList({
              data:ready[0].queue,
            });
          },2000);
        }
        else{
          if(pending.length>0){
            let tempList = [];
            let firstReady=true;
            queueList.forEach((queue)=>{
              if(queue.status==="aguardando" && firstReady){
                tempList.push({...queue,status:"iniciado"})
                firstReady=false;
              }
              else{
                tempList.push(queue)
              }
            });
            setQueueList(tempList);
          }
          else{
            setFinaliza(true);
          }
        }
        // eslint-disable-next-line
      },[queueList]);

  return (
    <Container>
      {(deleteItemInfo.loading||
        loadSegmentoInfo.loading||
        postSegmentoInfo.loading||
        loadVisibilitiesInfo.loading||
        loadTutorListInfo.losding||
        loadSubscriptionRulesInfo.loading||
        loadSchoolGradeListInfo.loading||
        loadProfileListInfo.loading||
        loadCategoriesInfo.loading||
        saveItemInfo.loading||
        loadItemInfo.loading||
        editItemInfo.loading
      ) && <FullScreenLoading />}
      {(deleteItemInfo.status||
        loadSegmentoInfo.status||
        postSegmentoInfo.status||
        loadVisibilitiesInfo.status||
        loadTutorListInfo.status||
        loadSubscriptionRulesInfo.status||
        loadSchoolGradeListInfo.status||
        loadProfileListInfo.status||
        loadCategoriesInfo.status||
        saveItemInfo.status||
        loadItemInfo.status||
        editItemInfo.status
      ) && <Error errorCode={401} />}
      <Accessibility />
      <Menu />
      <ContentBox>
        <Title>Formações</Title>
        <Form onSubmit={formik.handleSubmit}>
          {action === "edit" && (
            <DeleteButton text="Apagar" onClick={() => handleDelete(id)} />
          )}
          <Item>
            {categories.length > 0 &&
              categories.map((cat) => (
                <InputRadio
                  key={cat.id}
                  id={cat.id}
                  name="courseType"
                  text={cat.category}
                  onChange={formik.getFieldProps("courseType").onChange}
                  value={cat.id}
                  checked={formik.getFieldProps("courseType").value === cat.id}
                />
              ))}
          </Item>

          {/*--------------- Inicio Construção Area Segmentos ---------------*/}
          {formik.values.courseType !== "" && <ItemFloor>
            <InputSelect 
              columns = {90}
              onChange={(e)=>{
                formik.setFieldValue("segment", e.target.value);
              }}
              value={formik.values.segment}
              placeholder="Segmento da formação"
            >
              <option value="" defaultValue>Formação sem segmento</option>
              {segmento.map((seg) => (
                    <option key={seg.id} value={seg.id}>
                      {seg.category}
                    </option>
                  ))}
            </InputSelect>
            <ReadMoreButton
              text="Criar Segmento"
              type="button"
              onClick={()=>{setModalSegmentOpen(true);}}
            />
          </ItemFloor>}

          <Modal open={modalSegmentOpen} buttonClose={false}>
            <div>Criar Novo Segmento</div>
            <InputSegment>
              <InputText
                placeholder="Segmento"
                columns={80}
                onChange={(value)=>{setCreateSegment(value.target.value);}}
                value={createSegment}
              />
            </InputSegment>
            <ListButton>
              <ReadMoreButton
                text="Criar Segmento"
                type="button"
                enabled={formik.values.courseType!==""}
                onClick={()=>{postSegmento({data:{name:createSegment,idCategoryFather:formik.values.courseType}});}}
              />
              <ReadMoreButton
                text="Cancelar"
                type="button"
                onClick={()=>{setModalSegmentOpen(false)}}
              />
            </ListButton>
          </Modal>

          <Modal open={modalSegmentMessage.open} buttonClose={false}>
            {modalSegmentMessage.message}
            <ReadMoreButton
              text="Ok"
              type="button"
              onClick={()=>{
                if(modalSegmentMessage.load){
                  loadSegmento({
                    params: {
                      id: formik.getFieldProps("courseType").value,
                    }
                  });
                }
                setModalSegmentMessage({open:false,message:"",load:false});
              }}
              disabled={!finaliza}
            />
          </Modal>
          {/*--------------- Fim Construção Area Segmentos ---------------*/}
        
          {/*--------------- Inicio Construção Informações Simples ---------------*/}
          <Item>
            <InputText
              placeholder="Título da Formação"
              columns={90}
              name="title"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.title}
              error={
                formik.touched.title &&
                formik.errors.title &&
                formik.errors.title
              }
            />
          </Item>
          <Item>
            <InputText
              placeholder="Descrição da Formação"
              columns={90}
              name="description"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.description}
              error={
                formik.touched.description &&
                formik.errors.description &&
                formik.errors.description
              }
            />
          </Item>
          <Item>
            <InputText
              placeholder="Formador(es)"
              columns={90}
              name="teacher"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.teacher}
              error={
                formik.touched.teacher &&
                formik.errors.teacher &&
                formik.errors.teacher
              }
            />
          </Item>
          <Item>
            <InputText
              placeholder="Contato do Formador"
              columns={90}
              name="teacherContact"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.teacherContact}
              error={
                formik.touched.teacherContact &&
                formik.errors.teacherContact &&
                formik.errors.teacherContact
              }
            />
          </Item>
          
          {/*--------------- Fim Construção Informações Simples ---------------*/}
          
          {/*--------------- Inicio Construção Lista de Encontros ---------------*/}
          <Item>
            <Place>Encontros:</Place>
            <ListBox>
              {formik.values.meetings.length>0?
              formik.values.meetings.sort((a,b)=>{return a.eventDate-b.eventDate;}).map((meet,index)=>(
                <MeetInfo>
                  Data : {format(meet.eventDate, "dd/MM/yyyy")}<br/>
                  Inicio: {format(meet.eventBegin, "HH':'mm")}<br/>
                  Fim: {format(meet.eventEnd, "HH':'mm")}<br/>
                  Local: {meet.place}
                  <DeleteEvent
                    type="button"
                    onClick={() => handleDeleteMeet(meet.id)}
                  >
                    <MdClose size={22} color={themeFile.COLORS.hardRed} />
                  </DeleteEvent>
                </MeetInfo>
              ))
              :<Alert>Sem Encontros Cadastrados</Alert>}
            </ListBox>

            <ReadMoreButton
                text="Criar Encontro"
                type="button"
                onClick={()=>{setModalMeetOpen(true);}}
              />
            
            <Modal open={modalMeetOpen} buttonClose={false}>
              <MeetModal>
              <div>Criar Encontro:</div>
              <InputDate
                    label="Datas"
                    name={`meet.eventDate`}
                    value={checkInt(formikMeet.values.meet.eventDate)}
                    setField={formikMeet.setFieldValue}
                    onChange={formikMeet.handleChange}
                    error={
                      typeof formikMeet.errors.meet !== "undefined" &&
                      typeof formikMeet.errors.meet !== "undefined" &&
                      typeof formikMeet.touched.meet !== "undefined" &&
                      typeof formikMeet.touched.meet !== "undefined" &&
                      typeof formikMeet.touched.meet.eventDate !==
                        "undefined" &&
                      formikMeet.errors.meet.eventDate
                    }
                  />
                  <InputTime
                    label="Previsão de início"
                    name={`meet.eventBegin`}
                    value={checkInt(formikMeet.values.meet.eventBegin)}
                    setField={formikMeet.setFieldValue}
                    onBlur={formikMeet.handleBlur}
                    onChange={formikMeet.handleChange}
                    error={
                      typeof formikMeet.errors.meet !== "undefined" &&
                      typeof formikMeet.errors.meet !== "undefined" &&
                      typeof formikMeet.touched.meet !== "undefined" &&
                      typeof formikMeet.touched.meet !== "undefined" &&
                      typeof formikMeet.touched.meet.eventBegin !==
                        "undefined" &&
                      formikMeet.errors.meet.eventBegin
                    }
                  />
                  <InputTime
                    label="Previsão de término"
                    name={`meet.eventEnd`}
                    value={checkInt(formikMeet.values.meet.eventEnd)}
                    setField={formikMeet.setFieldValue}
                    onBlur={formikMeet.handleBlur}
                    onChange={formikMeet.handleChange}
                    error={
                      typeof formikMeet.errors.meet !== "undefined" &&
                      typeof formikMeet.errors.meet !== "undefined" &&
                      typeof formikMeet.touched.meet !== "undefined" &&
                      typeof formikMeet.touched.meet !== "undefined" &&
                      typeof formikMeet.touched.meet.eventEnd !==
                        "undefined" &&
                      formikMeet.errors.meet.eventEnd
                    }
                  />
                  <InputText
                    placeholder="Local ou link para encontro virtual"
                    columns={80}
                    name={`meet.place`}
                    onChange={formikMeet.handleChange}
                    onBlur={formikMeet.handleBlur}
                    value={formikMeet.values.meet.place}
                    error={
                      typeof formikMeet.errors.meet !== "undefined" &&
                      typeof formikMeet.errors.meet !== "undefined" &&
                      typeof formikMeet.touched.meet !== "undefined" &&
                      typeof formikMeet.touched.meet !== "undefined" &&
                      typeof formikMeet.touched.meet.place !==
                        "undefined" &&
                      formikMeet.errors.meet.place
                    }
                  />
              </MeetModal>
                <ListButton>
                  <ReadMoreButton
                    text="Criar Encontro"
                    type="button"
                    onClick={()=>{handleMeet({...formikMeet.values.meet,id:uuidv4()});setModalMeetOpen(false)}}
                    disabled={(typeof formikMeet.errors.meet !== "undefined")}
                  />
                  <ReadMoreButton
                    text="Cancelar"
                    type="button"
                    onClick={()=>{setModalMeetOpen(false);resetMeet();}}
                  />
                </ListButton>
            </Modal>
          </Item>
          {/*--------------- Fim Construção Lista de Encontros ---------------*/}

          <Item>
            <Place>Documentos:</Place>
            {formik.values.documents.length > 0 ? (
              <DocumentContainer>
                {formik.values.documents.map((doc) => (
                  <DocumentFile key={doc.id}>
                    {doc.url ? (
                      <DocumentUrl
                        href={`${process.env.REACT_APP_CDN_URL}/canalPedagogico/course/${doc.url}`}
                        target="_blank"
                      >
                        {doc.originalName}
                      </DocumentUrl>
                    ) : (
                      <DocumentName>{doc.originalName}</DocumentName>
                    )}

                    <DocumentSize>{doc.formatSize}</DocumentSize>
                    <DocumentDeleteButton
                      onClick={() => handleDeleteDocument(doc.id)}
                    >
                      <BsTrash
                        size={themeFile.SIZES.base * 22}
                        color={themeFile.COLORS.hardRed}
                      />
                    </DocumentDeleteButton>
                  </DocumentFile>
                ))}
              </DocumentContainer>
            ):<DocumentContainer>Nenhum documento anexado</DocumentContainer>}
            <InputFile
              accept="application/pdf"
              id="inputDocument"
              text="Anexar Documento"
              onChange={handleAttachFiles}
            />
          </Item>

          <Item>
            <Place>Visibilidade:</Place>
            <ListBox>
              <ContentVisibility>
                <InputRadio
                  id="public"
                  name="formType"
                  text="Público"
                  onChange={formik.getFieldProps("formType").onChange}
                  value="public"
                  checked={formik.getFieldProps("formType").value === "public"}
                />
                <InputRadio
                  id="private"
                  name="formType"
                  text="Restrito"
                  onChange={formik.getFieldProps("formType").onChange}
                  value="private"
                  checked={formik.getFieldProps("formType").value === "private"}
                />
              </ContentVisibility>
              {formik.values.formType === "private" && (<ContentVisibility>
                {visibilities.length > 0 &&
                  visibilities.map((vis) => (
                    <InputCheck
                      id={vis.id}
                      key={vis.id}
                      value={vis.id}
                      name="visibilities"
                      text={vis.description}
                      onChange={formik.handleChange}
                      checked={formik.values.visibilities.includes(vis.id)}
                    />
                  ))}
              </ContentVisibility>)}
              </ListBox>
          </Item>

          <Item>
            <InputDate
              label="Inicio das Inscrições"
              name={`subscriptionBegin`}
              value={checkInt(formik.values.subscriptionBegin)}
              setField={formik.setFieldValue}
              onChange={formik.handleChange}
              error={
                formik.errors.subscriptionBegin
              }
            />
            <InputDate
              label="Fim das Inscrições"
              name={`subscriptionEnd`}
              value={checkInt(formik.values.subscriptionEnd)}
              setField={formik.setFieldValue}
              onChange={formik.handleChange}
              error={
                formik.errors.subscriptionEnd
              }
            />
          </Item>

          <Item>
            <InputText
              placeholder="Carga Horária"
              columns={15}
              name="courseWorkload"
              type="number"
              min="0"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.courseWorkload}
              error={
                formik.touched.courseWorkload &&
                formik.errors.courseWorkload &&
                formik.errors.courseWorkload
              }
            />
          </Item>

           {action === "add" ? <Item>
            <InputCheck
              name="useGoogleClassroom"
              text={'Gerar Google Sala de Aula para a formação'}
              onChange={formik.handleChange}
              checked={formik.values.useGoogleClassroom}
            />
          </Item>:formik.values.useGoogleClassroom?<Item>Google classroom criado para esta formação</Item>:""}
          
          <Item>

            <InputCheck
              name="hasSubscription"
              text={'Inscrição realizada pelo canal pedagógico'}
              onChange={formik.handleChange}
              checked={formik.values.hasSubscription}
            />

          </Item>

          {/*--------------- Inicio Construção Lista de Regras da Formação ---------------*/}

          {formik.values.hasSubscription && 
            <Item>
              <InputText
                  placeholder="Limite de inscritos"
                  columns={15}
                  name="subscriptionsLimit"
                  type="number"
                  min="1"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.subscriptionsLimit}
                  error={
                    formik.touched.subscriptionsLimit &&
                    formik.errors.subscriptionsLimit &&
                    formik.errors.subscriptionsLimit
                  }
                />
            </Item>}

          {formik.values.hasSubscription && <Item>
            <Place>Regras de Inscrição:</Place>
            <ListBox column>
              {formik.values.subscriptionRules.length>0?<>

              {formik.values.subscriptionRules.filter((rule)=>{return rule.indexOf("663963cf-aa91-4451-9c90-cefb5561c7d5")>0;}).length>0 && <div>
                {formik.values.subscriptionRules.filter((rule)=>{return rule.indexOf("663963cf-aa91-4451-9c90-cefb5561c7d5")>0;}).map((rule)=><p>Para professores com HTPF</p>)} 
              </div>}

              {formik.values.subscriptionRules.filter((rule)=>{return rule.indexOf("cb1bbb7d-5ee8-4603-a234-383fff8373ee")>0;}).length>0 && <div>
                {formik.values.subscriptionRules.filter((rule)=>{return rule.indexOf("cb1bbb7d-5ee8-4603-a234-383fff8373ee")>0;}).map((rule)=><p>Para professores com 2ºRGF</p>)} 
              </div>}

              {formik.values.subscriptionRules.filter((rule)=>{return rule.indexOf("1b96897c-df19-4354-84ef-f6176d2ad7c2")>0;}).length>0 && <div>
                <p>Com turmas de:</p>
                <ul>
                  {formik.values.subscriptionRules.filter((rule)=>{return rule.indexOf("1b96897c-df19-4354-84ef-f6176d2ad7c2")>0;}).map((rule)=><li>{getGrade(JSON.parse(rule).value)}</li>)} 
                </ul>
              </div>}

              {formik.values.subscriptionRules.filter((rule)=>{console.log(rule,rule.indexOf("11aff2e9-c982-40ef-a199-115e5d6f87e3")>0);return rule.indexOf("11aff2e9-c982-40ef-a199-115e5d6f87e3")>0;}).length>0 && <div>
                <p>Para:</p>
                <ul>
                  {formik.values.subscriptionRules.filter((rule)=>{return rule.indexOf("11aff2e9-c982-40ef-a199-115e5d6f87e3")>0;}).map((rule)=><li>{getProfile(JSON.parse(rule).value)}</li>)} 
                </ul>
              </div>}

              </>:"Não Foram selecionadas Regras de Inscrição"}
            </ListBox>
            <ReadMoreButton type="button" text={"Selecionar Regras de Inscrição"} onClick={()=>{setModalRulesOpen(true)}}/>
            <Modal open={modalRulesOpen} buttonClose={false}>
              <RulesBlockModal>
                <InputCheckButton
                  id={"663963cf-aa91-4451-9c90-cefb5561c7d5"}
                  key={"663963cf-aa91-4451-9c90-cefb5561c7d5"}
                  value={JSON.stringify({
                            idSubscriptionRule:"663963cf-aa91-4451-9c90-cefb5561c7d5",
                            value:'1'
                        })}
                  name="subscriptionRules"
                  text={"Professores com HTPF"}
                  width={"25rem"}
                  onChange={(temp)=>{console.log(temp);formik.handleChange(temp)}}
                  checked={formik.values.subscriptionRules.includes(
                                  JSON.stringify({
                                                  idSubscriptionRule:"663963cf-aa91-4451-9c90-cefb5561c7d5",
                                                  value:'1'
                                                }))}
                />
                <InputCheckButton 
                  id={"cb1bbb7d-5ee8-4603-a234-383fff8373ee"}
                  key={"cb1bbb7d-5ee8-4603-a234-383fff8373ee"}
                  value={JSON.stringify({
                            idSubscriptionRule:"cb1bbb7d-5ee8-4603-a234-383fff8373ee",
                            value:'1',
                        })}
                  name="subscriptionRules"
                  text={"Professores com 2ºRGF"}
                  width={"25rem"}
                  onChange={(temp)=>{console.log(temp);formik.handleChange(temp)}}
                  checked={formik.values.subscriptionRules.includes(
                                  JSON.stringify({
                                                  idSubscriptionRule:"cb1bbb7d-5ee8-4603-a234-383fff8373ee",
                                                  value:'1',
                                                }))}
                />
              </RulesBlockModal>
                {subscriptionRules.map((rules)=>{
                  if(rules.idsubscription_rules==="1b96897c-df19-4354-84ef-f6176d2ad7c2"){
                    return (<Grade key={rules.idsubscription_rules}><p>{rules.title}:</p><RulesBlockModal>
                                {schoolGradeList.map((grade)=>(
                                  <InputCheckButton 
                                          id={grade.id}
                                          key={grade.id}
                                          value={JSON.stringify({
                                                    idSubscriptionRule:rules.idsubscription_rules,
                                                    value:grade.id,
                                                })}
                                          name="subscriptionRules"
                                          width={"25rem"}
                                          text={grade.title}
                                          onChange={formik.handleChange}
                                          checked={formik.values.subscriptionRules.includes(
                                                          JSON.stringify({
                                                                          idSubscriptionRule:rules.idsubscription_rules,
                                                                          value:grade.id,
                                                                        }))}
                                    />))}
                              </RulesBlockModal></Grade>)
                  }
                  if(rules.idsubscription_rules==="11aff2e9-c982-40ef-a199-115e5d6f87e3"){
                    return (<Grade key={rules.idsubscription_rules}><p>{rules.title}:</p><RulesBlockModal>
                                {profileList.map((profile)=>(
                                  <InputCheckButton 
                                          id={profile.idProfile}
                                          key={profile.idProfile}
                                          value={JSON.stringify({
                                                    idSubscriptionRule:rules.idsubscription_rules,
                                                    value:profile.idProfile,
                                                })}
                                          name="subscriptionRules"
                                          text={profile.profileName}
                                          width={"25rem"}
                                          height={"12rem"}
                                          onChange={formik.handleChange}
                                          checked={formik.values.subscriptionRules.includes(
                                                          JSON.stringify({
                                                                          idSubscriptionRule:rules.idsubscription_rules,
                                                                          value:profile.idProfile,
                                                                        }))}
                                    />))}
                              </RulesBlockModal></Grade>)
                  }
                  return (<></>);
                })}        
                <ListButton>
                  <ReadMoreButton type="button" text={"Fechar Seleção de regras"} onClick={()=>{setModalRulesOpen(false);}}/>
                </ListButton>
            </Modal>

            </Item>}

          {/*--------------- Fim Construção Lista de Regras da Formação ---------------*/}

          <Item>
            <Place>Tutor{formik.values.tutors.length>1?"es: ":": "}</Place>
            <ListBox>
              {formik.values.tutors.map((tutor,index)=>(
                <TutorInfo key={index}>
                  {`${tutorList.find((item)=>{return item.idUserHasProfile===tutor})?.name}`}
                </TutorInfo>))}
              {formik.values.tutors.length===0 && "Formação sem tutor"}
            </ListBox>
            <ReadMoreButton type="button" text={"Selecionar tutores"} onClick={()=>{openTutors();}}/>
            
            <Modal open={modalTutor} buttonClose={false}>
              <ModalTutor>
                {tutorList.map((tutor)=>(
                  <Tutor key={tutor.idUserHasProfile} selected={tempTutors.findIndex((item)=>{return item===tutor.idUserHasProfile})>=0} onClick={()=>{handleTutors(tutor.idUserHasProfile)}}>{tutor.name}</Tutor>
                ))}
              </ModalTutor>
              <ListButton>
                <ReadMoreButton type="button" text={"Cancelar"} onClick={()=>{setModalTutor(false);}}/>
                <ReadMoreButton type="button" text={"Limpar seleção"} onClick={()=>{setTempTutors([]);}}/>
                <ReadMoreButton type="button" text={"Atualizar tutores"} onClick={()=>{updateTutors();}}/>
              </ListButton>
            </Modal>
          </Item>

          {action === "add" && <>
            <Item>
              <InputCheck
                name="hasNumberOfClass"
                text={'Criar Multiplas Turmas'}
                onChange={formik.handleChange}
                checked={formik.values.hasNumberOfClass}
              />
            </Item>
            {formik.values.hasNumberOfClass && <Item>
              <InputText
                      placeholder="Número da turma inicial"
                      columns={30}
                      name="initialClassNumber"
                      type="number"
                      min="1"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.initialClassNumber}
                      error={
                        formik.touched.initialClassNumber &&
                        formik.errors.initialClassNumber &&
                        formik.errors.initialClassNumber
                      }
                    />
              <InputText
                      placeholder="Número da turma Final"
                      columns={30}
                      name="finalClassNumber"
                      type="number"
                      min="1"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.finalClassNumber}
                      error={
                        formik.touched.finalClassNumber &&
                        formik.errors.finalClassNumber &&
                        formik.errors.finalClassNumber
                      }
                    />
            </Item>}
          </>}

          <Controls>
            <CancelButton text="Cancelar" />
            <ConfirmButton
              text="Salvar"
              type="submit"
              disabled={!formik.isValid}
            />
          </Controls>
        </Form>
        <Modal open={modalOpen} buttonClose={false}>
          {queueList.map((queue)=>(<div key={queue.turma}>{formik.values.title} (turma {queue.turma}) - Status: {queue.status}</div>))}
          <ReadMoreButton
            text="Ok"
            type="button"
            onClick={()=>{navigate("/formacoes");}}
            disabled={!finaliza}
          />
        </Modal>
      </ContentBox>
      <Footer />
    </Container>
  );
};

export default CourseForm;
